import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';

function HomePage() {
  const currentYear = new Date().getFullYear();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-logo-container">
          <img src={`${process.env.PUBLIC_URL}/logo_transparent.png`} className="nav-logo" alt="Redder Media Logo" />
        </div>
        <div className="nav-items">
          <a href="#hero" className="nav-item" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>Home</a>
          <a href="#about" className="nav-item" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a>
          <a href="#projects" className="nav-item" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}>Projects</a>
        </div>
      </nav>
      
      <main className="main-content">
        <section id="hero" className="hero">
          <h1 className="title">Redder Media</h1>
          <p className="subtitle">
            A company that specializes in building AI-driven software, digital systems, and helpful mobile apps.
          </p>
        </section>

        <section id="about" className="about-section">
          <div className="about-content">
            <h2 className="section-title">About Us</h2>
            <div className="about-text">
              <p>
                At Redder Media, we're passionate about creating innovative digital products and experiences that leave a lasting impact. Our commitment to excellence drives us to push boundaries and deliver exceptional results across all our ventures.
              </p>
              <p>
                Through our family of companies and communities, we're building the future of digital entertainment, content creation, and a world of possibilities, one project at a time.
              </p>
            </div>
          </div>
        </section>

        <section id="projects" className="companies-section">
          <h2 className="section-title">Our Projects</h2>
          <div className="company-cards">
            <a href="https://thekeystoneapp.com" target="_blank" rel="noopener noreferrer" className="company-card">
              <div className="company-logo-container">
                <img src={`${process.env.PUBLIC_URL}/keystone.png`} className="company-logo" alt="Keystone Logo" />
              </div>
              <div className="company-content">
                <h3 className="company-name">Keystone</h3>
                <p className="company-description">
                  The #1 app for overcoming doubt to achieve your dreams by aligning your actions now with who you wish to become in the future.
                </p>
              </div>
            </a>
            <a href="https://scale66.com" target="_blank" rel="noopener noreferrer" className="company-card">
              <div className="company-logo-container">
                <img src={`${process.env.PUBLIC_URL}/scale66.png`} className="company-logo" alt="Scale66 Logo" />
              </div>
              <div className="company-content">
                <h3 className="company-name">Scale66</h3>
                <p className="company-description">
                  An easy AI-powered content creation platform that scales your content creation and distribution across multiple platforms.
                </p>
              </div>
            </a>
            <Link to="/privacy-policy" className="company-card">
              <div className="company-logo-container">
                <img src={`${process.env.PUBLIC_URL}/a_virtue_a_day.png`} className="company-logo" alt="A Virtue A Day Logo" />
              </div>
              <div className="company-content">
                <h3 className="company-name">A Virtue A Day</h3>
                <p className="company-description">
                  A practice exercise tracker for developing virtues in a philosophic way and improving your overall life.
                </p>
              </div>
            </Link>
            <a href="https://discord.me/thekeystonecollective" target="_blank" rel="noopener noreferrer" className="company-card">
              <div className="company-logo-container">
                <img src={`${process.env.PUBLIC_URL}/keystone.png`} className="company-logo" alt="The Keystone Collective Logo" />
              </div>
              <div className="company-content">
              <h3 className="company-name">The Keystone Collective</h3>
                <p className="company-description">
                  A vibrant Discord community fostering connection, creativity, and collaboration in the digital space.
                </p>
              </div>
            </a>
          </div>
        </section>
      </main>
      
      <footer className="footer">
        <p>© {currentYear} Redder Media. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default App;
